var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.243,
    height: 70.621,
    viewBox: "0 0 64.243 70.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-217.379 -449)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 58,
    x2: 58,
    transform: "translate(221.5 459.5)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1173 -823)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 7,
    transform: "translate(1422 1272)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398,1320.353v2.824h48v-2.824S1444.588,1302,1422,1302,1398,1320.353,1398,1320.353Z",
    transform: "translate(0 -22.941)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.529,1410v11.294c0,15.529-19.765,22.588-19.765,22.588S1416,1436.824,1416,1421.294V1410",
    transform: "translate(-13.765 -105.529)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.727,1516.371a24.264,24.264,0,0,0,3.358,1.8",
    transform: "translate(-67.085 -186.872)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440,1464c1.412,4.235,5.647,8.471,7.649,9.993",
    transform: "translate(-32.118 -146.824)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7,
    transform: "translate(1408 1293)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 11,
    transform: "translate(1415 1289)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7,
    transform: "translate(1422 1293)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 8,
    transform: "translate(1429 1292)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5,
    transform: "translate(1436 1295)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    y1: 58,
    x2: 58,
    transform: "translate(219.5 457.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutIcon);
export default __webpack_public_path__ + "static/media/nut-icon.2bb8b3b6.svg";
export { ForwardRef as ReactComponent };